import { useQuery } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `GET /api/health` — public liveness probe. Returns `{ ok: true, ts: number }`.
 * Useful as a connectivity check on the frontend boot path.
 */
export function useHealth() {
  const client = useStudioClient();
  return useQuery({
    queryKey: ['health'],
    queryFn: async () => {
      const res = await client.api.health.$get();
      if (!res.ok) throw await parseApiError(res);
      return res.json();
    },
  });
}
